module.exports = __webpack_public_path__ + "static/img/2023_9_8_7.b79b0540.b79b054.png";


//////////////////
// WEBPACK FOOTER
// ./assets/img/2023_9_8_7.b79b0540.png
// module id = Gnek
// module chunks = 0